"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _gatsby = require("gatsby");

var _semanticUiReact = require("semantic-ui-react");

require("./BlogPostCard.css");

var _proptypes = require("../../../../utils/proptypes");

var _Image = _interopRequireDefault(require("../../../../atoms/Image"));

var _ObjectUtils = _interopRequireDefault(require("../../../../utils/ObjectUtils"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var BlogPostCard = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(BlogPostCard, _React$PureComponent);

  var _super = _createSuper(BlogPostCard);

  function BlogPostCard() {
    (0, _classCallCheck2["default"])(this, BlogPostCard);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BlogPostCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          slug = _this$props.slug,
          title = _this$props.title,
          publishedAt = _this$props.publishedAt,
          summary = _this$props.summary,
          gatsbyHeroImage = _this$props.gatsbyHeroImage,
          heroImage = _this$props.heroImage;
      return /*#__PURE__*/_react["default"].createElement(_gatsby.Link, {
        to: "".concat(slug)
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card, {
        className: "blog-post-card"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: "blog-post-card-image",
        src: gatsbyHeroImage ? gatsbyHeroImage.childImageSharp : heroImage,
        wrapped: true
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Header, null, title), _ObjectUtils["default"].isRenderable(publishedAt) && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Meta, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "date"
      }, (0, _moment["default"])(publishedAt).format('LL'))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Description, null, summary)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Content, {
        extra: true,
        textAlign: "right"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "See More", /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "right arrow"
      })))));
    }
  }]);
  return BlogPostCard;
}(_react["default"].PureComponent);

exports["default"] = BlogPostCard;
BlogPostCard.propTypes = {
  title: _propTypes["default"].string.isRequired,
  slug: _propTypes["default"].string.isRequired,
  publishedAt: _propTypes["default"].string,
  summary: _propTypes["default"].string,
  heroImage: _propTypes["default"].oneOfType([_propTypes["default"].string, _proptypes.GatsbyImagePropType])
};
BlogPostCard.defaultProps = {
  summary: '',
  heroImage: null,
  publishedAt: null
};